import React, { FC, useEffect, useState } from 'react'
import Image from 'react-bootstrap/Image'
import { Link, useLocation, useHistory } from 'react-router-dom'
import useLogoutUser from '../../hooks/authentication/useLogoutUser'
import useUserWithRole from '../../hooks/authentication/useUserWithRole'
import client_logo from '../../assets/customizations/logos/client_banner.svg'
import { appConfig } from '../../assets/customizations/config'
import { companyMessage } from '../../assets/i18n/i18n'
import useEnvironment from '../../hooks/location/useEnviroment'
import { getApiServer } from '../../utils/domain'
import { isDemoTenant } from '../../utils/helpers'


const Header: FC = () => {
  const [activeTab, setActiveTab] = useState('')
  const [showSecondaryNav, setShowSecondaryNav] = useState(true)
  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    switch (location.pathname) {
      case '/':
      case '/admin':
      case '/login':
        setActiveTab('home')
        break
      case '/data-sharing':
        setActiveTab('data-sharing')
        break
      case '/data-sharing/import-health-plans':
        setActiveTab('data-sharing')
        break
      case '/data-sharing/sharing-with-providers':
        setActiveTab('data-sharing')
        break
      case '/drug-lookup':
        setActiveTab('drug-lookup')
        break
      case '/help':
        setActiveTab('help')
        break
      case '/my-account':
        setActiveTab('my-account')
        break
      case '/available-apps':
        setActiveTab('available-apps')
        break
      case '/register/member':
      case '/register/requestor':
      case '/register/contact':
      case '/register/validate':
      case '/register/create':
        setActiveTab('register')
        break
      default:
        setActiveTab('')
        break
    }

    setShowSecondaryNav(
      !location.pathname.includes('/developers')
    )
  }, [location.pathname])

  const { user, removeUser, status, role } = useUserWithRole()

  const logoutUser = useLogoutUser()
  const handleLogoutUser = () => {
    logoutUser.mutate({ refreshToken: user.refresh_token })
  }

  useEffect(() => {
    if (logoutUser.isSuccess) {
      removeUser()
      history.push('/login', { alertMessage: 'You have been logged out successfully.' })
    }
  }, [logoutUser.isSuccess])

  const { data: environment } = useEnvironment()


  const getNavLinkClass = (tabName: string) => `nav-link${activeTab === tabName ? ' active-link' : ' inactive-link'}`

  const renderNavItem = (to: string, label: string, className = '') => (
    <li className="nav-item">
      <Link className={`nav-link ${className}`} to={to}>
        {label}
      </Link>
    </li>
  )

  const getHomeText = () => (user && role === 'admin' ? 'Admin Home' : 'Home')

  return (
    <header >
      <div className="header-branding">
        <Link to="/" className="nav-link">
          <div className="client_banner">
            <Image
              src={client_logo}
              className="img-fluid"
              alt={companyMessage?.PreferedName || 'Company Logo'} />
          </div>

          <div className="portal_banner" role="banner" aria-label="Member Portal">
            <h1 className="member-portal-heading">{companyMessage?.DataPortalTitle}</h1>
          </div>
        </Link>
      </div>
      {showSecondaryNav && status !== 'loading' && (
        <nav id="main_nav" aria-label="main navigation">
          <ul className="nav justify-content-center">
            {renderNavItem(user ? '/' : '/login', getHomeText(), getNavLinkClass('home'))}

            {!user && (
              <>
                {appConfig.show_help && renderNavItem('/help', 'Help', getNavLinkClass('help'))}
                {renderNavItem('/available-apps', 'Available Apps', getNavLinkClass('available-apps'))}
                {!appConfig.use_sso && renderNavItem('/register/requestor', 'Register', getNavLinkClass('register'))}
                {environment?.showDrugLookup && renderNavItem('/drug-lookup', 'Drug Lookup', getNavLinkClass('drug-lookup'))}
                {environment?.serverSecurity === 'oAuth2' && (
                  <li className="nav-item">
                    <a
                      className={`nav-link ${getNavLinkClass('login')}`}
                      href={`${getApiServer()}/oAuth2/start`}
                    >
                      Log In
                    </a>
                  </li>
                )}
              </>
            )}

            {user && (
              <>
                {role === 'member' && isDemoTenant(environment?.tenant || '') && renderNavItem('/data-sharing', 'Data Sharing', getNavLinkClass('data-sharing'))}
                {renderNavItem('/my-account', 'My Account', getNavLinkClass('my-account'))}
                {renderNavItem('/available-apps', 'Available Apps', getNavLinkClass('available-apps'))}
                {appConfig?.show_help && renderNavItem('/help', 'Help', getNavLinkClass('help'))}
                {environment?.showDrugLookup && renderNavItem('/drug-lookup', 'Drug Lookup', getNavLinkClass('drug-lookup'))}
                <li className="nav-item">
                  <Link className="nav-link inactive-link" to="#" onClick={handleLogoutUser}>
                    Log Out
                  </Link>
                </li>
              </>
            )}
          </ul>
        </nav>
      )}
    </header>
  )
}

export default Header